import { apiRequest } from './apiUtils';
import {
  GetMarketplaceProfileResponseDto,
  UpsertMarketplaceProfileDto,
  UpsertMarketplaceProfileResponseDto,
} from '@foodfluence/shared';

export const marketplaceProfileApi = {
  getMarketplaceProfile: async (influencerId: string): Promise<GetMarketplaceProfileResponseDto> => {
    return apiRequest({
      method: 'GET',
      endpoint: '/marketplace-profile',
      influencerId,
    });
  },

  upsert: async (
    influencerId: string,
    data: UpsertMarketplaceProfileDto
  ): Promise<UpsertMarketplaceProfileResponseDto> => {
    return apiRequest({
      method: 'PUT',
      endpoint: '/marketplace-profile',
      data,
      influencerId,
    });
  },
};
